/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Footer from "./Footer/Footer";
import HeaderOptimized from "./Header/HeaderOptimized";
import { useDispatch } from "react-redux";
import { onClientConfigurationSubmit } from "../Store/Slices/clientConfigurationSlice";
import { ClientInfo, getConfigValue, trackEvent } from "../Components/Utility/Utility";
import NonLoginModal from "../Components/NonLoginModal/NonLoginModal";
// import { onGetMail } from "../Store/Slices/sendMailSlice";
// import { onSaveCredsGet } from "../Store/Slices/cardDataSlice";



const Layout = (props) => {
  const { Component } = props;
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isLoginDisable = getConfigValue(clientConfigurations, "isLogin");

    const handleConfirm = () => {
    const redirectUrl = isLoginDisable?.url;
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  useEffect(() => {
    dispatch(onClientConfigurationSubmit());
    // dispatch(onGetMail())
    // dispatch(onSaveCredsGet("V3IntegrationFront"));
    sessionStorage.removeItem("apiCalled");
    const isLogin = sessionStorage.getItem("login");
    if (isLoginDisable?.isLoginDisabled === 1 && !isLogin && !sessionStorage.getItem("blockDirectUrl")) {
      setModalOpen(true);
    }
  }, []);

  return (
    <>
      <HeaderOptimized setModalOpen={setModalOpen} modalOpen={modalOpen} />
      <Component />
      <NonLoginModal show={modalOpen} onConfirm={handleConfirm} />
      <Footer />
    </>
  );
};

export default Layout;
